<template>
  <div>
    <b-navbar
      class="shadow-sm py-1"
      toggleable="md"
      type="dark"
      variant="dark"
      fixed="top"
      id="nav-admin"
    >
      <b-navbar-brand class="" href="#">Carnival Dashboard</b-navbar-brand>

      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav>
        <!-- Right aligned nav items -->
        <b-navbar-nav class="ml-auto">
          <b-nav-item href="https://leicestercarnival.co.uk">
            Visit Site
          </b-nav-item>
          <b-nav-item
            v-if="$route.meta.page"
            @click="toRoute({ name: $route.meta.page })"
          >
            View Page
          </b-nav-item>
          <b-nav-item-dropdown ref="nav-drpdown" right>
            <!-- Using 'button-content' slot -->
            <template slot="button-content"
              ><em class="text-light">Edit Pages</em></template
            >
            <!--<li class="dropdown-item pointer" @click="toRoute('/admin/home')">Home</li>-->
            <b-dropdown-item>
              <router-link
                class="link text-decoration-none d-block w-100"
                to="home"
                active-class="text-success"
                >Home
              </router-link>
            </b-dropdown-item>
            <b-dropdown-item>
              <router-link
                class="link text-decoration-none"
                to="about"
                active-class="text-success"
              >
                About
              </router-link>
            </b-dropdown-item>
            <b-dropdown-item>
              <router-link
                class="link text-decoration-none"
                to="carnival"
                active-class="text-success"
              >
                Carnival
              </router-link>
            </b-dropdown-item>
            <b-dropdown-item>
              <router-link
                class="link text-decoration-none"
                to="contact"
                active-class="text-success"
              >
                Contact
              </router-link>
            </b-dropdown-item>
            <b-dropdown-item>
              <router-link
                class="link text-decoration-none"
                to="tickets"
                active-class="text-success"
                >Tickets</router-link
              >
            </b-dropdown-item>
            <b-dropdown-item>
              <router-link
                class="link text-decoration-none"
                to="galleries"
                active-class="text-success"
                >Gallery</router-link
              >
            </b-dropdown-item>
          </b-nav-item-dropdown>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
  </div>
</template>

<script>
export default {
  computed: {},
};
</script>

<style scoped lang="scss"></style>
